import React from "react";

const PitchDeckTableRowHeaderCenter = ({ displayName }) => {
  return (
    <tr className="idea-checker-table-break">
      <th colSpan={3} className="idea-checker-table-data-right">
        {displayName}
      </th>
    </tr>
  );
};

export default PitchDeckTableRowHeaderCenter;
